<template>
  <div class="organization-members">
    <label class="pending-toggle">
      <el-switch :value="showPending" @input="$emit('update:showPending', $event)" active-color="#13ce66" inactive-color="#CCC" />
      <el-badge :value="pendingCount" :hidden="pendingCount === 0" type="warning" class="pending-badge">
        <span class="label">Show pending invites</span>
      </el-badge>
    </label>
    <el-table :data="filteredMembers" @cell-click="gotoMember">
      <el-table-column
        label="-"
        width="50">
        <template slot-scope="scope">
          <member-controls :member="scope.row" @remove="removeMember" simple />
        </template>
      </el-table-column>
      <el-table-column
        label="Name">
          <template slot-scope="scope">
            <div class="sub-prop">
              {{ scope.row.user.name }}
              <div class="group-chips" v-if="memberGroups(scope.row).length > 0">
                <el-tag
                  v-for="g in memberGroups(scope.row)"
                  :key="g.id"
                  size="mini"
                  type="info">
                  {{ g.name }}
                </el-tag>
              </div>
            </div>
          </template>
      </el-table-column>
      <el-table-column
        v-if="$screen.desktop"
        label="Contact">
        <template slot-scope="scope">
          <div>

            <div>{{ scope.row.user.email }}</div><div>{{ scope.row.user.phoneNumber || '-' }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        width="120">
          <template slot-scope="scope">
            <member-controls
              :member.sync="scope.row"
              :organization="organization"
              @remove="removeMember"
              @priceCreated="$emit('priceCreated', $event)"
              @refresh="$emit('refresh')" />
          </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
import MemberControls from './Members/MemberControls'

export default {
  name: 'OrganizationMembers',
  components: { MemberControls },
  props: {
    organization: {
      type: Object,
      required: true
    },
    search: {
      type: String,
      required: true
    },
    members: {
      type: Array,
      required: true
    },
    showControls: {
      type: Boolean,
      required: false
    },
    showPending: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      loaders: {
        adminState: false
      },
      bindMembers: this.members,
      showDialog: false
    }
  },
  watch: {
    members () {
      this.bindMembers = this.members
    }
  },
  computed: {
    sortedMembers () {
      const m = this.bindMembers
      return m.sort((a, b) => {
        a.loading = false
        b.loading = false
        return b.pending - a.pending
      })
    },
    pendingCount () {
      return this.bindMembers.filter(m => m.pending || m.invite).length
    },
    filteredMembers () {
      return this.sortedMembers.filter(item => {
        const isPending = item.pending || item.invite
        if (this.showPending && !isPending) return false
        if (!this.showPending && isPending) return false
        if (item['user']['name'].toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
          return item
        }
        if (item['user']['email'].toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
          return item
        }
      })
    }
  },
  methods: {
    removeMember (member) {
      this.bindMembers.splice(this.bindMembers.indexOf(member), 1)
    },
    gotoMember (row, col) {
      if (col.label !== undefined && col.label !== '-') {
        this.$router.push({ name: 'OrganizationMember', params: { id: row.user.id } })
      }
    },
    memberGroups (orgUser) {
      const memberships = orgUser.groupMemberships || orgUser.groups
      if (!memberships) return []
      return memberships
        .map(m => m.organizationUserGroup || m.group || m)
        .filter(g => g && g.name)
    }
  }
}
</script>

<style lang="scss" scoped>
  .new-user {
    position: absolute;
    left: 22px;
    color: #f7ba2a;
    font-size: 12px;
    font-weight: 600;
    border-radius: 1px;
  }

  .organization-members {
    position: relative;
  }

  .controls-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .group-chips {
    margin-top: 4px;
    display: flex;
    flex-wrap: wrap;

    .el-tag {
      font-size: 10px;
      margin-right: 4px;
    }
  }

  .pending-toggle {
    display: inline-flex;
    align-items: center;
    margin-bottom: 12px;

    .pending-badge {
      margin-left: 12px;
    }

    .label {
      font-size: 12px;
      color: $text-light;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Members.vue